import React from "react";
import { CrudFormType } from "../../shared/form/types/FormTypes";

import FieldSelector from "../../shared/form/components/FieldSelector";
import {
  UpdateArea,
  CreateArea,
  DeleteArea,
  AreasCRUDDependencies,
} from "./services/service.areas";
import { useAreaForm } from "./services/useAreaForm";
import { AreaInterface } from "./models/AreaTypes";
import { useLangLabels } from "../../shared/lang/services/useLangLabels";
import { CUEntityFormPropsType, UIFormInterface } from "../../shared/form/types/CRUDTypes";
import { useCreateUpdate } from "../../shared/form/hooks/useCreateUpdate";
import DefaultFormLayout from "../../components/form/DefaultFormLayout/DefaultFormLayout";
import { useSessionContext } from "../session/store/sessionContext";

type props = CUEntityFormPropsType<AreaInterface> & { isDataUpdated?: boolean };

const CUAreaForm: React.FC<props> = ({ item, actionType, isDataUpdated }) => {
  const { tagFP } = useSessionContext();

  //DB
  const { action, resetStatus, status, error, message } = useCreateUpdate(
    {
      create: CreateArea,
      update: UpdateArea,
      delete: DeleteArea,
    },
    actionType,
    AreasCRUDDependencies
  );

  //UI
  const { lang } = useLangLabels();

  const { uiModel, handleSubmit, resetForm } = useAreaForm(tagFP, item);

  const ui = (() => {
    const formName = lang.areas.title.plural;
    switch (actionType) {
      case CrudFormType.create:
        const create: UIFormInterface = {
          icon: "add",
          title: `${lang.actionTypes.create} ${formName.toLowerCase()}`,
          variant: "button",
          mode: "modal",
        };

        return create;

      case CrudFormType.update:
        const update: UIFormInterface = {
          icon: "edit",
          title: `${lang.actionTypes.update} ${formName.toLowerCase()}`,
          variant: "iconButton",
          mode: "content",
        };
        return update;
    }
  })();

  //Methods
  const submit = (data: AreaInterface) => {
    action(data);
  };

  const handleReset = () => {
    resetStatus();
    resetForm();
  };

  return (
    <DefaultFormLayout
      componentMode={ui.mode}
      buttonIcon={ui.icon}
      buttonVariant={ui.variant}
      buttonText={ui.title}
      popoverTitle={ui.title}
      {...{ queryStatus: status, error, alertStatusMessage: message }}
      buttonAction={handleSubmit(submit)}
      onClose={handleReset}
      resetForm={handleReset}
      isDataUpdated={isDataUpdated}
    >
      {uiModel.map((props, index) => (
        <FieldSelector key={index} fieldProps={props} />
      ))}
    </DefaultFormLayout>
  );
};

export default CUAreaForm;
